<template>
    <div>
        <h2 class="calculator__header">{{prepareHeadline()}}</h2>
        <p>{{preparePerex()}}</p>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import isUndefined from 'lodash/isUndefined';

    export default {
        name: 'CalculationHeadline',
        computed: {
            ...mapGetters('calculation', ['selectedProject'])
        },
        methods: {
            getStep() {
                const {projectSlug, constructionId} = this.$route.params;
                if (projectSlug && constructionId) {
                    return 3;
                } else if (projectSlug) {
                    return 2;
                }
                return 1;
            },
            prepareHeadline() {
                const {projectSlug, constructionId} = this.$route.params;
                const selectedProject = this.selectedProject;
                let title = 'Výpočet spotřeby materiálu';
                if (selectedProject) {
                    if (!isUndefined(constructionId)) {
                        title = `${selectedProject.singularName} - výpočet materiálu`;
                    } else if (!isUndefined(projectSlug)) {
                        title = `${selectedProject.singularName} - výpočet materiálu`;
                    }
                }
                document.title = title;
                return title;
            },
            preparePerex() {
                const currentStep = this.getStep();
                const selectedProject = this.selectedProject;
                let perex = '';

                if (selectedProject && currentStep === 2) {
                    if (selectedProject.singularName === 'Příčka') {
                        perex = 'Jednou z předních výhod sádrokartonových příček je jejich rychlá a snadná montáž, kterou zvládnete i svépomocí. Před výběrem a kalkulací toho správného řešení je dobré vědět, co od této příčky očekáváte a jaké mají být její požadované vlastnosti. Sádrokarton vám může pomoci při odhlučnění interiéru nebo zajistit vysokou únosnost stěny.';
                    }
                    else if (selectedProject.singularName === 'Předstěna') {
                        perex = 'Předsazené stěny jsou konstrukce, které se montují pouze z jedné strany místnosti ke stávající stěně. Nejčastěji z těch důvodů, že současná stěna nemá vyhovující vlastnosti – není dostatečně nosná; je nevzhledná; neizoluje zvuk tak, jak bychom potřebovali. Sádrokartonové desky můžete v některých případech lepit tmelem Rifix přímo na původní zeď (tzv. suchá omítka) nebo použít konstrukci z ocelových profilů.';
                    }
                    else if (selectedProject.singularName === 'Podlaha') {
                        perex = 'Systémy suchých podlah Rigips využívají jen minimum mokrých procesů. Můžete vybírat ze dvou základních variant podlahových dílců – ze sádrokartonových desek Rigistabil nebo sádrovláknitých desek Rigidur. Skladbu podlahy lze doplnit o vyrovnávací podsyp v případě nerovností podkladu, o podlahové vytápění nebo o minerální izolaci pro ještě lepší akustické vlastnosti.';
                    }
                    else if (selectedProject.singularName === 'Podhled') {
                        perex = 'SDK podhledy slouží nejen ke snížení světlé výšky místnosti, ale i k odhlučnění interiéru a při řešení optimální prostorové akustiky. Sádrokarton zbytečně nezatěžuje stropy a nabízí designové řešení, které zakryje veškeré instalace bez zbytečného sekání.';
                    }
                    else if (selectedProject.singularName === 'Podkroví') {
                        perex = 'Sádrokarton k podkroví neodmyslitelně patří. Můžete ho využít nejen při stavbě půdní vestavby, ale i při rekonstrukci staré půdy. Vybrané SDK konstrukce vám zajistí veškeré požadavky na požární odolnost i akustickou izolaci. Vybrat si můžete ze dvou variant dle tloušťky tepelné izolace pod krokev.';
                    }
                    else if (selectedProject.singularName === 'Omítka') {
                        perex = 'Omítnutím interiérových stěn sádrovými omítkami Rigips získáte stěny nevšedních vlastností. Vlastnosti sádry regulují vlhkost v místnosti a vytváří tak příjemné prostředí. Sádrové omítky jsou dokonale hladké, nedrží se na nich plísně ani prach a jsou vhodné pro alergiky. Skvěle přenáší drobná pnutí ve stěně a nepraskají. Aplikují se ručně i strojně.';
                    }
                }
                return perex;
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/calculation/calculator/steps/Headline.vue